
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import MutableInputContainer from '@/components/inputs/MutableInputContainer.vue';
import StateButton from '@/components/inputs//StateButton.vue';
import AccountToken from './AccountToken.vue';
import AllUsers from './permissions/AllUsers.vue';
import AccountFileTile from './AccountFileTile.vue';
import CommandTile from './CommandTile.vue';

import { BModal } from 'bootstrap-vue';
import moment from 'moment';
import userx from '@/store/modules/userx';
import mwx from '@/store/modules/mediumwarex';
import progressToastx from '@/store/modules/progressToastx';
import programx from '@/store/modules/programx';
import { htmlEscape } from '@/util/htmlEscape';

import {
	AccountData,
	SoftwareType,
	EditState,
	UpdateAccountSubmission,
	ChangeProgramSubmission,
	ExpireCurrentTokenSubmission,
	BanTokenSubmission,
	UpdateAccountRemarkSubmission,
	permissionsGroups,
	UpdateAccountExprirySubmission,
	DownloadFormat,
} from '@/store/models.def';
import accountx from '../../store/modules/accountx';

export interface AccountProfile extends AccountData {
	isEditing: boolean;
}

@Component({
	components: {
		MutableInputContainer,
		AccountToken,
		StateButton,
		AllUsers,
		AccountFileTile,
		CommandTile,
	},
})
export default class AccountProfileTile extends Vue {
	public get supportLvl() {
		return userx.supportLvl;
	}
	public get groups() {
		return permissionsGroups;
	}
	public get gdbPaths() {
		const data = this.data as any;
		return this.groups.map((group) => ({
			group,
			data: data[`${group}LastAvailable`],
		}));
	}
	public get commands() {
		return accountx.commands;
	}
	public get lastSync() {
		return moment(this.data.lastSync).format('DD/MM/YYYY HH:mm:ss');
	}
	public get validatePath(): boolean | null {
		if (!this.validatePathNow) {
			return null;
		}
		// return this.path.substr(-4).toLocaleLowerCase() === '.fdb';
		return true;
	}
	public get validatePayroll(): boolean | null {
		if (!this.validatePayrollNow) {
			return null;
		}
		return (
			!this.payroll || this.payroll.substr(-4).toLocaleLowerCase() === '.fdb'
		);
	}
	public get validateExpiry(): boolean | null {
		if (!this.validateExpiryNow) {
			return null;
		}
		const mmt = moment(this.expiry, 'DD/MM/YYYY');
		return mmt.isValid();
	}
	public get validateInterval(): boolean | null {
		if (!this.validateIntervalNow) {
			return null;
		}
		const interval = Number(this.interval);
		return interval === interval;
	}
	public get validateProgramId() {
		if (!this.validateProgramIdNow) {
			return null;
		}
		if (
			this.programId === null ||
			!programx.allPrograms.find((sm) => sm.id === this.programId)
		) {
			return false;
		}
		return true;
	}
	public get validateCompanyRemark(): boolean | null {
		if (!this.validateCompanyRemarkNow) {
			return null;
		}
		return this.companyRemark !== '';
	}
	public get validateBackendurl(): boolean | null {
		if (!this.validateBackendurlNow) {
			return null;
		}
		if (!this.backendUrl) {
			return false;
		}
		try {
			const url = new URL(this.backendUrl);
			if (url.protocol !== 'https:') { return false; }
			const h = url.hostname;
			const allowed = ['.sql.com.my', '.gobi.my', '.papan.ai'];
			return allowed.some((d) => h === d.slice(1) || h.endsWith(d));
		} catch {
			return false;
		}
	}
	public get softwareType(): string {
		const found = mwx.softwareTypesVt.find((vt) => vt.value === this.data.softwareType);
		return found ? found.text : 'SQL';
	}

	public get createdAt(): string {
		return moment(this.data.createdAt).format('DD/MM/YYYY HH:mm:ss');
	}
	public get availablePrograms(): Array<string | { value: any; text: string }> {
		const programs = programx.groupedPrograms;
		if (!this.softwareType || !programs) {
			return [];
		}
		return programs[this.data.softwareType as SoftwareType].reduce(
			(options, data) => {
				options.push(data.id);
				return options;
			},
			[] as string[],
		);
	}
	public get extend30DaysLabel() {
		return 'Extend 30 Days';
	}
	public get purgeSyncLabel() {
		return 'Purge Sync';
	}
	public get syncNowLabel() {
		return 'Sync Now';
	}
	public get sendLogsLabel() {
		return 'Send Logs';
	}
	public get sendSettingsLabel() {
		return 'Send Settings';
	}
	public get sendAccountsLabel() {
		return 'Send Accounts';
	}
	public get restartLabel() {
		return 'Restart MW';
	}
	public get removeAccountLabel() {
		return 'Remove Account';
	}
	public get expiryDate() {
		const mmt = moment(this.data.expiryTime);
		this.expiry = mmt.isValid() ? mmt.format('DD/MM/YYYY') : '';
		return this.expiry;
	}
	public get expired() {
		return Date.now() > this.data.expiryTime;
	}
	@Prop() public data!: AccountData;

	public path: string = 'localhost/3050:';
	public pathEditState: EditState = 'done';
	public validatePathNow: boolean = false;
	public payroll: string = '';
	public payrollEditState: EditState = 'done';
	public validatePayrollNow: boolean = false;

	public expiry: string = '';
	public expiryEditState: EditState = 'done';
	public validateExpiryNow: boolean = false;

	public interval: number | string = 300;
	public intervalEditState: EditState = 'done';
	public validateIntervalNow: boolean = false;
	public programId: string = '';
	public programIdEditState: EditState = 'done';
	public validateProgramIdNow: boolean = false;
	public companyRemark: string = '';
	public companyRemarkEditState: EditState = 'done';
	public validateCompanyRemarkNow: boolean = false;
	public backendUrl: string = '';
	public backendUrlEditState: EditState = 'done';
	public validateBackendurlNow: boolean = false;

	public newTokenState: EditState = 'active';

	public purgeSyncState: EditState = 'active';
	public syncNowState: EditState = 'active';
	public sendLogsState: EditState = 'active';
	public sendLogsLines: number | null = null;
	public sendLogsIndex: number | null = null;
	public sendSettingsState: EditState = 'active';
	public sendAccountsState: EditState = 'active';
	public restartState: EditState = 'active';
	public removeAccountState: EditState = 'active';
	public extend30DaysState: EditState = 'active';
	public downloadAllState: EditState = 'active';
	public downloadAllLabel: string = 'Download All';

	public onPathChange() {
		this.path = this.path.replace(/\\/g, '/');
	}
	@Watch('pathEditState')
	public onPathEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			this.path = this.data.path;
		}
	}
	public async submitPath() {
		this.validatePathNow = true;
		this.path = this.path.replace(/\\/g, '/');
		if (!this.validatePath) {
			this.pathEditState = 'active';
			return;
		}
		if (this.path === this.data.path) {
			await this.$nextTick();
			this.pathEditState = 'done';
			return;
		}
		const submission: UpdateAccountSubmission = {
			accountId: this.data.accountId,
			path: this.path,
		};
		const result = await mwx.updateAccount(submission);
		if (result.success) {
			this.validatePathNow = false;
			this.pathEditState = 'done';
		} else {
			this.pathEditState = 'active';
			progressToastx.error({
				title: `${this.data.companyName}`,
				state: `Fail to update path.`,
			});
		}
	}
	@Watch('payrollEditState')
	public onPayrollEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			this.payroll = this.data.payroll || '';
		}
	}
	public onPayrollChange() {
		this.payroll = this.payroll.replace(/\\/g, '/');
	}
	public async submitPayroll() {
		this.validatePayrollNow = true;
		this.payroll = this.payroll.replace(/\\/g, '/');
		console.log(this.validatePayroll, this.payrollEditState);
		if (!this.validatePayroll) {
			await this.$nextTick();
			this.payrollEditState = 'active';
			return;
		}
		if (this.payroll === this.data.payroll) {
			await this.$nextTick();
			this.payrollEditState = 'done';
			return;
		}
		const submission: UpdateAccountSubmission = {
			accountId: this.data.accountId,
			payroll: this.payroll,
		};
		const result = await mwx.updateAccount(submission);
		if (result.success) {
			this.validatePayrollNow = false;
			this.payrollEditState = 'done';
		} else {
			this.payrollEditState = 'active';
			progressToastx.error({
				title: `${this.data.companyName}`,
				state: `Fail to update payroll path.`,
			});
		}
	}
	@Watch('expiryEditState')
	public onExpiryEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			const mmt = moment(this.data.expiryTime);
			this.expiry = mmt.isValid() ? mmt.format('DD/MM/YYYY') : '';
		}
	}
	public onExpiryChange() {
		const mmt = moment(this.expiry, 'DD/MM/YYYY');
		this.expiry = mmt.isValid() ? mmt.format('DD/MM/YYYY') : '';
	}
	public async submitExpiry() {
		this.validateExpiryNow = true;

		const mmt = moment(this.expiry, 'DD/MM/YYYY');
		if (!mmt.isValid()) {
			await this.$nextTick();
			this.expiryEditState = 'active';
			return;
		}
		const expiryTime = mmt.endOf('day').valueOf();
		if (expiryTime === this.data.expiryTime) {
			await this.$nextTick();
			this.expiryEditState = 'done';
			return;
		}
		const submission: UpdateAccountExprirySubmission = {
			accountId: this.data.accountId,
			expiryTime,
		};
		const result = await mwx.updateAccountExpiry(submission);
		if (result.success) {
			this.validateExpiryNow = false;
			this.expiryEditState = 'done';
		} else {
			this.expiryEditState = 'active';
			progressToastx.error({
				title: `${this.data.companyName}`,
				state: `Fail to update expiry date.`,
			});
		}
	}
	@Watch('intervalEditState')
	public onIntervalEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			this.interval = this.data.interval;
		}
	}
	public async submitInterval() {
		this.validateIntervalNow = true;
		if (!this.validateInterval) {
			await this.$nextTick();
			this.intervalEditState = 'active';
			return;
		}
		if (this.interval === this.data.interval) {
			await this.$nextTick();
			this.intervalEditState = 'done';
			return;
		}
		const submission: UpdateAccountSubmission = {
			accountId: this.data.accountId,
			interval: Number(this.interval),
		};
		const result = await mwx.updateAccount(submission);
		if (result.success) {
			this.validateIntervalNow = false;
			this.intervalEditState = 'done';
		} else {
			this.intervalEditState = 'active';
			progressToastx.error({
				title: `${this.data.companyName}`,
				state: `Fail to update interval.`,
			});
		}
	}
	@Watch('backendUrlEditState')
	public onBackendurlEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			this.backendUrl = this.data.backendUrl || '';
		}
	}
	public async submitBackendurl() {
		this.validateBackendurlNow = true;
		if (!this.validateBackendurl) {
			await this.$nextTick();
			this.backendUrlEditState = 'active';
			return;
		}
		const submission: UpdateAccountSubmission = {
			accountId: this.data.accountId,
			backendUrl: this.backendUrl.replace(/\/+$/, ''),
		};
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: 'Updating Backend URL...',
			variant: 'info',
		});
		const result = await mwx.updateAccount(submission);
		if (result.success) {
			this.validateBackendurlNow = false;
			this.backendUrlEditState = 'done';
			progressToastx.done({
				id: toastId,
				state: `Backend URL updated.`,
			});
		} else {
			this.backendUrlEditState = 'active';
			progressToastx.error({
				id: toastId,
				state: `Fail to update Backend URL.`,
			});
		}
	}
	@Watch('programIdEditState')
	public onProgramIdEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			this.programId = this.data.programId;
		}
	}
	public async submitProgramId() {
		this.validateProgramIdNow = true;
		if (!this.validateProgramId) {
			await this.$nextTick();
			this.programIdEditState = 'active';
			return;
		}
		if (this.programId === this.data.programId) {
			await this.$nextTick();
			this.programIdEditState = 'done';
			return;
		}
		const submission: ChangeProgramSubmission = {
			accountId: this.data.accountId,
			programId: this.programId,
		};
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: 'Updating Program ID...',
			variant: 'info',
		});
		const result = await mwx.changeProgramId(submission);
		if (result.success) {
			this.validateIntervalNow = false;
			this.programIdEditState = 'done';
			progressToastx.done({
				id: toastId,
				state: `Update Program ID Succeed.`,
			});
		} else {
			this.programIdEditState = 'active';
			progressToastx.error({
				id: toastId,
				state: `Fail to update programId.`,
			});
		}
	}
	@Watch('companyRemarkEditState')
	public onCompanyRemarkEditStateChanged(val: EditState, oldVal: EditState) {
		if (val === 'active' && oldVal === 'done') {
			this.companyRemark = this.data.companyRemark || '';
		}
	}
	public async submitCompanyRemark() {
		this.validateCompanyRemarkNow = true;
		if (!this.validateCompanyRemark) {
			await this.$nextTick();
			this.companyRemarkEditState = 'active';
			return;
		}
		if (this.companyRemark === this.data.companyRemark) {
			await this.$nextTick();
			this.companyRemarkEditState = 'done';
			return;
		}
		const submission: UpdateAccountRemarkSubmission = {
			accountId: this.data.accountId,
			companyRemark: this.companyRemark,
		};
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: 'Updating Company Remark...',
			variant: 'info',
		});
		const result = await mwx.updateAccountRemark(submission);
		if (result.success) {
			this.validateCompanyRemarkNow = false;
			this.companyRemarkEditState = 'done';
		} else {
			this.companyRemarkEditState = 'active';
			progressToastx.error({
				id: toastId,
				state: `Fail to update Company Remark.`,
			});
		}
	}
	public async updateToken(id: string, value: boolean) {
		console.log('change token', value);
		const submission: BanTokenSubmission = {
			accountId: this.data.accountId,
			tokenPath: 'token.forbidden',
			value,
		};
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: value ? 'Banning current token...' : 'Unbanning current token...',
			variant: 'info',
		});
		const result = await mwx.banOrUnbanToken(submission);
		if (result.success) {
			progressToastx.done({
				id: toastId,
				state: value ? 'Ban succeed!' : 'Unban succeed!',
			});
		} else {
			progressToastx.error({
				id: toastId,
				state: `Fail to update old token <${id}>.`,
			});
		}
	}

	public async updateOldToken(id: string, value: boolean) {
		const submission: BanTokenSubmission = {
			accountId: this.data.accountId,
			tokenPath: `oldTokens.${id}.forbidden`,
			value,
		};
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: value ? 'Banning an old token...' : 'Unbanning an old token...',
			variant: 'info',
		});
		const result = await mwx.banOrUnbanToken(submission);
		if (result.success) {
			progressToastx.done({
				id: toastId,
				state: value ? 'Ban succeed!' : 'Unban succeed!',
			});
		} else {
			progressToastx.error({
				id: toastId,
				state: `Fail to update old token <${id}>.`,
			});
		}
	}
	public async expireCurrentToken(doNotMakeNew: boolean = false) {
		if (this.newTokenState !== 'active') {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: doNotMakeNew ? 'Expiring Current Token...' : 'Making New Token...',
			variant: 'info',
		});
		const accountId = this.data.accountId;
		const submission: ExpireCurrentTokenSubmission = { accountId, doNotMakeNew };

		this.newTokenState = 'sending';
		const result = await mwx.expireCurrentToken(submission);
		this.newTokenState = 'active';
		if (result.success) {
			progressToastx.done({
				id: toastId,
				state: doNotMakeNew ? 'Previous Token Expired...' : 'New token created!',
			});
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async extend30Days() {
		if (this.extend30DaysState !== 'active') {
			return;
		}
		let start = moment().valueOf();
		if (this.data.expiryTime > start) {
			start = this.data.expiryTime;
		}
		const submission: UpdateAccountExprirySubmission = {
			accountId: this.data.accountId,
			expiryTime: moment(start)
				.add(30, 'day')
				.endOf('day')
				.valueOf(),
		};
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Extending for 30 days...`,
			variant: 'info',
		});
		this.extend30DaysState = 'sending';
		const result = await mwx.updateAccountExpiry(submission);
		this.extend30DaysState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Extended for 30 days.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async purgeSync() {
		if (this.purgeSyncState !== 'active') {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Sending Purge Sync Command...`,
			variant: 'info',
		});
		this.purgeSyncState = 'sending';
		const result = await mwx.purgeSync(this.data.accountId);
		this.purgeSyncState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Purge Sync Command Sent.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async syncNow() {
		if (this.syncNowState !== 'active') {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Sending Sync Command...`,
			variant: 'info',
		});
		this.syncNowState = 'sending';
		const result = await mwx.syncNow(this.data.accountId);
		this.syncNowState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Sync Command Sent.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public openSendLogsModal() {
		if (this.sendLogsState !== 'active') {
			return;
		}
		const modal = this.$refs.sendLogsModal as BModal;
		if (modal) { modal.show(); }
	}
	public resetSendLogsForm() {
		this.sendLogsLines = null;
		this.sendLogsIndex = null;
	}
	public async confirmSendLogs() {
		const payload: any = {};
		if (this.sendLogsLines != null) { payload.lines = this.sendLogsLines; }
		if (this.sendLogsIndex != null) { payload.index = this.sendLogsIndex; }
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Sending Send Logs Command...`,
			variant: 'info',
		});
		this.sendLogsState = 'sending';
		const result = await mwx.sendLogs({ accountId: this.data.accountId, payload });
		this.sendLogsState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Send Logs Command Sent.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async sendSettings() {
		if (this.sendSettingsState !== 'active') {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Sending Send Settings Command...`,
			variant: 'info',
		});
		this.sendSettingsState = 'sending';
		const result = await mwx.sendSettings(this.data.accountId);
		this.sendSettingsState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Send Settings Command Sent.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async sendAccounts() {
		if (this.sendAccountsState !== 'active') {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Sending Send Accounts Command...`,
			variant: 'info',
		});
		this.sendAccountsState = 'sending';
		const result = await mwx.sendAccounts(this.data.accountId);
		this.sendAccountsState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Send Accounts Command Sent.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async restart() {
		if (this.restartState !== 'active') {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.data.companyName}`,
			state: `Sending Restart Command...`,
			variant: 'info',
		});
		this.restartState = 'sending';
		const result = await mwx.restart(this.data.accountId);
		this.restartState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Restart Command Sent.` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	public async addAccount() {
		const result = await userx.addMyAccount(this.data);
		if (result.success) {
			progressToastx.done({
				title: 'Success',
				state: `Added <b>${this.data.companyName}</b> to My Accounts`,
			});
		} else {
			progressToastx.error({ title: 'Failed', state: result.errorMessage });
		}
	}
	public async removeAccount() {
		if (!this.data) {
			return;
		}
		const h = this.$createElement;
		const titleVNode = h('div', {
			domProps: {
				innerHTML: `<i class="fas fa-exclamation-triangle fa-fw text-warning"></i>  <b>Remove Account</b>`,
			},
		});
		const msgVNode = h('div', {
			class: 'alert alert-danger',
			domProps: {
				innerHTML: `Are you sure you want to remove <b>${htmlEscape(
					this.data.companyName,
				)}</b>?<br/>This action can not be undone!`,
			},
		});
		const toRemove = await this.$bvModal.msgBoxConfirm([msgVNode], {
			title: [titleVNode],
			size: 'md',
			buttonSize: 'sm',
			okVariant: 'danger',
			cancelVariant: 'link-gray',
			okTitleHtml: `<i class="fa fa-times"></i> Remove`,
			headerClass: 'p-2 border-bottom-0',
			footerClass: 'p-2 border-top-0',
		});
		if (toRemove) {
			const toastId = await progressToastx.add({
				title: `${htmlEscape(this.data.companyName)}`,
				state: `Removing account...`,
				variant: 'info',
			});
			const result = await mwx.removeAccount(this.data.accountId);
			if (result.success) {
				progressToastx.done({ id: toastId, state: `Account removed!` });
			} else {
				progressToastx.error({ id: toastId, state: result.errorMessage });
			}
		}
	}
	public navigateToDashboard() {
		window.open(`https://bi.sql.com.my/#/account/${this.data.accountId}/dashboard`);
	}
	public async downloadAll(format: DownloadFormat) {
		if (this.downloadAllState !== 'active') { return; }
		this.downloadAllState = 'sending';
		this.downloadAllLabel = 'Preparing...';
		try {
			await accountx.downloadAllZips({
				format,
				onProgress: (current, total, group) => {
					this.downloadAllLabel = `Processing ${group} (${current}/${total})...`;
				},
			});
			this.downloadAllLabel = 'Download All';
		} catch (error) {
			console.error('Failed to download all:', error);
			this.downloadAllLabel = 'Download All';
		}
		this.downloadAllState = 'active';
	}
}
